import React, { useContext } from 'react'
import Image from '../../img'
import { useHistory } from 'react-router-dom'
import { LOGOUT_USER } from '../../store/constants'
import { store } from '../../store'

function Navbar(){
    const { dispatch } = useContext(store)
    const history = useHistory()
    function signOut(){
        localStorage.clear()
        dispatch({
            type: LOGOUT_USER
        })
        history.replace('/')
    }

    return (
        <div>
            <nav className="navbar navbar-expand-sm navbar-dark" style={{ backgroundColor: "#2D373E"}}>
                <div data-testid="logo-navbar-test" className="navbar-brand ml-4 d-flex align-content-center" style={{ cursor: "pointer" }} >
                    <img src={ Image.SmadavWhite } style={{ height: "50px" }} alt="logo"/>
                    <span style={{ fontWeight: "bold", fontSize: "30px"}}>Smadav Protect</span>
                </div>
                <button className="navbar-toggler d-lg-none" type="button" data-toggle="collapse" data-target="#collapsibleNavId" aria-controls="collapsibleNavId"
                    aria-expanded="false" aria-label="Toggle navigation"></button>
                <div className="collapse navbar-collapse" id="collapsibleNavId">
                    <ul className="navbar-nav mr-auto mt-2 mt-lg-0">
                        <li className="nav-item active">
                        </li>
                        <li className="nav-item">
                        </li>
                        <li className="nav-item dropdown">
                        </li>
                    </ul>
                    <button type="button" data-testid="logout-test" className="btn btn-danger mr-3" onClick={ signOut }> SignOut </button>
                </div>
            </nav>
        </div>
    )
}

export default Navbar